import { Outlet, Navigate } from "react-router-dom";

const OceanPublicLayout = () => {
  const storedToken = localStorage.getItem("token");

  if (storedToken) {
    // return <Navigate to="/oceantrackedlist" />;
    return <Navigate to="/tracking-management" />;
  }
 
  return <Outlet />;
};

export default OceanPublicLayout;